module.exports = __webpack_public_path__ + "static/media/smartphones2.e6f98a05.png";